import type { DominoRuleSet, ScoringKind } from '../variants/types.js';
import { FIVES_SCORING } from './fivesScoring.js';
import { PENALTY_SCORING } from './penaltyScoring.js';
import type { MatchStanding, ScoringPolicy } from './types.js';

export type {
  HandEndInput,
  HandEndOutcome,
  MatchStanding,
  PlayScoreInput,
  ScoringPolicy,
} from './types.js';
export { FIVES_SCORING } from './fivesScoring.js';
export { PENALTY_SCORING } from './penaltyScoring.js';
export { winnerLeader } from './nextLeader.js';

const POLICIES: Record<ScoringKind, ScoringPolicy> = {
  fives: FIVES_SCORING,
  penalty: PENALTY_SCORING,
};

export function getScoringPolicy(ruleSet: DominoRuleSet): ScoringPolicy {
  return POLICIES[ruleSet.scoring];
}

/**
 * Seats that won the match. Use this at match end instead of
 * `lastResult.winnerSeats` — a match can end mid-hand (a Muggins claim),
 * when `lastResult` still describes an earlier hand.
 */
export function matchWinnerSeats(
  state: MatchStanding & { readonly ruleSet: DominoRuleSet },
): readonly number[] {
  return getScoringPolicy(state.ruleSet).matchWinnerSeats(state);
}
